import { Table, Row, Col, Button } from 'reactstrap';
import { useContext, useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Context as AuthContext } from '../../../contexts/AuthContext';
import HireAgreementsService from '../../../services/HireAgreements';
import { toast } from 'react-toastify';

type HireAgreementsFormProps = {
  isOpen: boolean;
};

const HireAgreementsForm = ({ isOpen }: HireAgreementsFormProps) => {
  const history = useHistory();
  const { token }: any = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [hireAgreementsList, setHireAgreementsList] = useState<any[]>([]);

  useEffect(() => {
    if (isOpen) {
      listData();
    }
  }, [isOpen]);

  const listData = async () => {
    try {
      const result = await HireAgreementsService(token).list();
      setHireAgreementsList(result.data || []);
    } catch (e: any) {
      toast.error(e?.response?.data?.message || 'No data Found!');
    }
  };

  const deleteSettings = async (e: React.FormEvent, id: string) => {
    e.preventDefault();
    if (loading) return;

    setLoading(true);
    try {
      await HireAgreementsService(token).delete(id);
      toast.success('Deleted successfully!');
      listData();
    } catch (e: any) {
      const message = String(e?.response?.data?.message || 'Delete error!');
      toast.error(message);
    } finally {
      setLoading(false);
    }
  };

  const handleNewAgreement = () => {
    history.push('/hire-agreements/new');
  };

  const handleAssignClick = (agreementId: string) => {
    history.push(`/hire-agreements/assign/${agreementId}`);
  };

  const handleEditClick = (agreementId: string) => {
    history.push(`/hire-agreements/${agreementId}/edit`);
  };

  return (
    <>
      <Row>
        <Col>
          <Button onClick={handleNewAgreement} color="primary">
            <i className="fas fa-plus" />
            <span>Create New</span>
          </Button>
        </Col>
      </Row>
      <Table className="align-items-center table-flush" responsive>
        <tbody>
          <tr>
            <th>Name</th>
            <th>Action</th>
          </tr>
          {hireAgreementsList?.length === 0 && (
            <tr>
              <td colSpan={2} className="text-center">
                Data not found
              </td>
            </tr>
          )}
          {hireAgreementsList.map((agreement: any) => (
            <tr key={`hireAgreements-modal-${agreement.id}`}>
              <td>
                {agreement.name}
                {agreement.category === 'MANAGEMENT' && (
                  <span
                    style={{
                      marginLeft: 8,
                      padding: '2px 8px',
                      background: '#E0E7FF',
                      color: '#3730A3',
                      borderRadius: 10,
                      fontSize: 11,
                      fontWeight: 600,
                    }}
                  >
                    Management
                  </span>
                )}
              </td>
              <td>
                <Button
                  style={{
                    border: 'none',
                    boxShadow: 'none',
                    background: '#FFFFFF',
                    padding: 0,
                    alignItems: 'center',
                    transition: 'filter 0.3s ease',
                    filter: 'brightness(1)',
                    color: '#416adb',
                  }}
                  onMouseEnter={(e) => (e.currentTarget.style.filter = 'brightness(1.2)')}
                  onMouseLeave={(e) => (e.currentTarget.style.filter = 'brightness(1)')}
                >
                  <a
                    href={agreement.file}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="d-flex flex-column align-items-center"
                  >
                    <i className="fas fa-download" />
                  </a>
                </Button>
                <i
                  className="fas fa-users text-info ml-2"
                  style={{ cursor: 'pointer' }}
                  title="Assign to Employees"
                  onClick={() => handleAssignClick(agreement.id)}
                />
                <i
                  className="fas fa-edit text-primary ml-2"
                  style={{ cursor: 'pointer' }}
                  title="Edit"
                  onClick={() => handleEditClick(agreement.id)}
                />
                <i
                  className="far fa-trash-alt text-danger ml-2"
                  style={{ cursor: 'pointer' }}
                  title="Delete"
                  onClick={(e) => deleteSettings(e, agreement.id)}
                ></i>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </>
  );
};

export default HireAgreementsForm;
